import template from './template.html';
import controller from './controller';

const startDate = new Date();
startDate.setHours(0, 0, 0, 0);

const endDate = new Date();
endDate.setMonth(endDate.getMonth() + 12);
endDate.setHours(23, 59, 59, 999);

export default {
  url:
    '/dashboard?author&category&courseAudience&credits&deliveryMethod&endTime&license&location&name&pageSize&sortType&startTime&subjectArea&tags&vendor&view',
  stateName: 'User Dashboard',
  data: {
    specialClass: 'fixed-sidebar'
  },
  params: {
    category: {
      type: 'string',
      value: '',
      squash: true
    },
    license: {
      type: 'string',
      value: '',
      squash: true
    },
    startTime: {
      type: 'int',
      value: startDate.getTime(),
      squash: false
    },
    endTime: {
      type: 'int',
      value: endDate.getTime(),
      squash: false
    }
  },
  reloadOnSearch: false,
  views: {
    'a@app': {
      template,
      controller,
      controllerAs: 'DashboardCtrl'
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/controllers/users/dashboard/index.js